module.exports = __webpack_public_path__ + "static/media/IMG_20180324_134717.d67433aa.jpg";